[
{
  "link": "/temperatura",
  "name": "Температура"
},
{
  "link": "/vetrjanka",
  "name": "Ветрянка"
},
{
  "link": "/pnevmonija",
  "name": "Пневмония"
},
{
  "link": "/povysennoe-davlenie",
  "name": "Повышенное давление"
},
{
  "link": "/diabet",
  "name": "Диабет"
},
{
  "link": "/prostuda",
  "name": "Простуда"
},
{
  "link": "/detskij-nasmork",
  "name": "Детский насморк"
},
{
  "link": "/detskij-kasel",
  "name": "Детский кашель"
},
{
  "link": "/tosnota",
  "name": "Тошнота"
},
{
  "link": "/kokljus",
  "name": "Коклюш"
},
{
  "link": "/ponos",
  "name": "Понос"
},
{
  "link": "/izzoga",
  "name": "Изжога"
},
{
  "link": "/bol",
  "name": "Боль"
},
{
  "link": "/bol-v-spine",
  "name": "Боль в спине"
},
{
  "link": "/golovnaja-bol",
  "name": "Головная боль"
},
{
  "link": "/bol-v-zivote",
  "name": "Боль в животе"
},
{
  "link": "/bol-v-gorle",
  "name": "Боль в горле"
},
{
  "link": "/dermatit",
  "name": "Дерматит"
},
{
  "link": "/vakcinacija",
  "name": "Вакцинация"
},
{
  "link": "/anemija",
  "name": "Анемия"
},
{
  "link": "/golovokruzenie",
  "name": "Головокружение"
},
{
  "link": "/narusenija-moceispuskanija",
  "name": "Нарушения мочеиспускания"
},
{
  "link": "/grippa",
  "name": "Грипп"
},
{
  "link": "/allergija",
  "name": "Аллергия"
},
{
  "link": "/konjunktivit",
  "name": "Конъюнктивит"
}]